module.exports = __webpack_public_path__ + "media/developerVideo.ab40bea3.mp4";